'use strict';

import React from 'react';
import classnames from 'classnames';

const iconCache = {};

/**
 * Component for custom or fontawesome icon.
 *
 * Icons for liferay: http://nickpiesco.github.io/alloy-ui-font-awesome-cheatsheet/
 * Custom icons are generated to images/icons directory from their source icons
 * in images/icons/src. Check generate-icons.js.
 *
 * icon config is as follows:
 * {
 *  type: type of icon ["custom"|"fa"]
 *  name: if fontawesome, fontawesome classname (e.g. "icon-music")
 *        if custom, the icon's name (e.g. "ajanvaraus").
 *  color: color of icon. fa icon colors are defined by class key in _icons.scss.
 *         Custom icon colors are created when generating (white, darkblue, lightblue)
 * }
 * */
const OTIcon = ({ config, className, children, ...rest }) => {
  let { type, name, color = type === 'custom' ? 'white' : 'default' } = config;

  let classNames = [className];

  // custom icon
  if (config.type === 'custom') {
    let src = null;
    if (iconCache[`${name}-${color}`]) {
      src = iconCache[`${name}-${color}`];
    } else {
      try {
        src = require(`../../images/icons/${name}-${color}.svg`).default;
        iconCache[`${name}-${color}`] = src;
      } catch (err) {
        console.error(
          'COULD NOT LOAD ICON',
          `../../images/icons/${name}-${color}.svg`,
          err
        );
      }
    }

    return (
      <div className={classnames('ot-icon-wrapper', classNames)} {...rest}>
        <img alt={`Ikoni: ${name}`} src={src} />
        {children}
      </div>
    );
    // fontawesome icon
  } else if (type === 'fa') {
    return (
      <i
        className={classnames(
          name,
          'fa ot-icon',
          color && `ot-icon--${color}`,
          classNames
        )}
        {...rest}
      >
        {children}
      </i>
    );
  } else {
    return null;
  }
};

export default OTIcon;
